import { CanvasElementType } from '@y42/json-schema';
import type { VisualizationCanvasElementUIModel } from '../visualization-canvas-element.model';

const editableInViewMode = new Set([CanvasElementType.Comment, CanvasElementType.Emoji]);

export function isEditableInViewMode(item: VisualizationCanvasElementUIModel) {
  return editableInViewMode.has(item.type);
}
